import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../../hotel.service';

@Component({
  selector: 'app-near-by-filter',
  templateUrl: './near-by-filter.component.html',
  styleUrls: ['./near-by-filter.component.scss']
})
export class NearByFilterComponent implements OnInit {

  isCollapsed = false;
  protected subs = new SubSink();
  hotelsCopy: any;
  uniquePOIs: any[] = [];
  selectedPOIs: string[] = []; // Array to store selected POIs

  constructor(private hotelService: HotelService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.subs.sink = this.hotelService.hotelsCopy.subscribe(res => {
      if (res.length) {
        this.hotelsCopy = res;
        this.uniquePOIs = this.getUniquePOIs(res);
      } else {
        this.hotelsCopy = [];
      }
      this.cdr.detectChanges();
    });
  }

  // Function to filter unique POIs from the hotels data
  getUniquePOIs(hotels) {
    const pois = hotels.reduce((acc, hotel) => {
      let parsedLocations = [];
  
      if (hotel.NearByLocation) {
        if (typeof hotel.NearByLocation === 'string') {
          try {
            parsedLocations = JSON.parse(hotel.NearByLocation);
          } catch (error) {
            console.error('Error parsing NearByLocation:', error, 'Hotel ID:', hotel.id);
          }
        } else if (Array.isArray(hotel.NearByLocation)) {
          parsedLocations = hotel.NearByLocation;
        }
      }
      
      return acc.concat(parsedLocations);
    }, []);
  
    // Filter out duplicate POIs based on `poiName`
    const uniquePOIs = pois.filter((poi, index, self) =>
      index === self.findIndex((p) => p.poiName.trim().toLowerCase() === poi.poiName.trim().toLowerCase())
    );
  
    return uniquePOIs;
  }
  

  // Handle checkbox selection for multiple POIs
  onPOIChange(poiName: string, isChecked: boolean) {
    // Get the current value (array) of selectedPOIs
    let currentPOIs = this.hotelService.selectedPOIs.getValue(); 
  
    if (isChecked) {
      // Add the selected POI if it's not already in the array
      if (!currentPOIs.includes(poiName)) {
        currentPOIs.push(poiName);
      }
    } else {
      // Remove the POI if unchecked
      currentPOIs = currentPOIs.filter(poi => poi !== poiName);
    }
  
    // Update the BehaviorSubject with the modified array
    this.hotelService.selectedPOIs.next(currentPOIs);
  
    // Trigger filter update based on the current selection
    this.applyFilters();
  }
  

  applyFilters() {
    this.hotelService.setByNearByLoc();
  }
}
